// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/WhatAreWeSection/WhatAreWeSection.css
// module id = 988
// module chunks = 0